import React from 'react'
import { Link } from 'react-router-dom'

import Navbar from '../../components/navbar'
import VideoModalOne from '../../components/video-modal-one'
import VideoModalTwo from '../../components/video-modal-two'
import ProjectFilter from '../../components/project-filter'
import ClientThree from '../../components/client-three'
import Shape from '../../components/shape'
import Footer from '../../components/footer'

import bg1 from '../../assets/images/home/bg01.png'
import aboutImg from '../../assets/images/accordion.jpg'

import { featureData } from '../../data/startup'

export default function IndexItSolution() {
  return (
    <>
     <Navbar/> 

    <section className="bg-home d-flex align-items-center bg-soft-primary" style={{backgroundImage:`url(${bg1})`, backgroundPosition:'center'}}>
      <div className="container">
          <div className="row align-items-center mt-5">
              <div className="col-lg-6 col-md-7">
                  <div className="title-heading position-relative mt-4" style={{zIndex: '1'}}>
                      <div className="alert bg-soft-primary alert-pills" role="alert">
                          <span className="badge bg-danger rounded-pill me-2"> Hot </span>
                          <span className="alert-content"> Best It Solutions </span>
                      </div>
                      <h1 className="heading text-dark fw-bold title-dark mb-3">Best solution and grow your business easier</h1>
                      <p className="para-desc text-muted title-dark">Start work with <span className="text-primary">Leaping</span>. Build responsive, mobile-first projects on the web with the world's most popular front-end component library.</p>
                      <div className="watch-video mt-4 pt-2">
                          <Link to="#" className="btn btn-primary mb-2 me-2">Get Started</Link>
                          <div className="watch-video mt-4 pt-2 d-inline-block">
                              <VideoModalOne/>
                          </div>
                      </div>
                  </div>
              </div>
          </div>
      </div>
    </section>

    <section className="section">
      <div className="container">
          <div className="row justify-content-center">
              <div className="col-12 text-center">
                  <div className="section-title mb-4 pb-2">
                      <h4 className="title mb-4">Design Features & Services</h4>
                      <p className="text-muted para-desc mx-auto mb-0">Build responsive, mobile-first projects on the web with the world's most popular front-end component library.</p>
                  </div>
              </div>
          </div>

          <div className="row">
            {featureData.map((item,index)=>{
              return(
                  <div className="col-lg-4 col-md-6 col-12 mt-4 pt-2" key={index}>
                      <div className="feature p-3 py-4 rounded">
                          <i className={`text-primary float-start me-3 mt-2 mdi-36px ${item.icon}`}></i>
                          <div className="content d-block overflow-hidden">
                              <h4 className="title">{item.title}</h4>
                              <p className="text-muted mt-2">{item.desc}</p>
                              <Link to="#" className="text-dark">Read More <i className="mdi mdi-chevron-right align-middle"></i></Link>
                          </div>
                      </div>
                  </div>
              )
            })}
          </div>
      </div>

      <div className="container mt-100 mt-60">
          <div className="row align-items-center">
              <div className="col-lg-5 col-md-6">
                  <div className="position-relative">
                      <img src={aboutImg} className="img-fluid shadow rounded" alt=""/>
                      <VideoModalTwo/>
                  </div>
              </div>

              <div className="col-lg-7 col-md-6 mt-4 pt-2 mt-sm-0 pt-sm-0">
                  <div className="section-title ms-md-4">
                      <h4 className="title mb-4">Who We Are ?</h4>
                      <p className="text-muted">Build responsive, mobile-first projects on the web with the world's most popular front-end component library.</p>
                      <p className="text-muted">It seems that only fragments of the original text remain in the Lorem Ipsum texts used today. One may speculate that over the course of time certain letters were added or deleted at various positions within the text. This might also explain why one can now find slightly different versions. Due to the age of the Lorem Ipsum text there are no copyright issues to contend with.</p>
                      <Link to="/contact" className="btn btn-outline-primary mt-2"><i className="mdi mdi-phone"></i> Contact Us</Link>
                  </div>
              </div>
          </div>
      </div>
    </section>

    <section className="section bg-light" id="portfolio">
      <div className="container">
          <div className="row">
              <div className="col-12 text-center">
                  <div className="section-title mb-4 pb-2">
                      <h4 className="title mb-4">Work & Project</h4>
                      <p className="text-muted para-desc mx-auto mb-0">Build responsive, mobile-first projects on the web with the world's most popular front-end component library.</p>
                  </div>
              </div>
          </div>
      </div>

      <div className="container-fluid mt-4 pt-2">
          <ProjectFilter/>
      </div>

      <div className="container mt-100 mt-60">
          <div className="row">
              <div className="col-12 text-center">
                  <div className="section-title mb-4 pb-2">
                      <h4 className="title mb-4">Review From Customer's</h4>
                      <p className="text-muted para-desc mx-auto mb-0">Build responsive, mobile-first projects on the web with the world's most popular front-end component library.</p>
                  </div>
              </div>
          </div>

          <div className="row justify-content-center">
              <div className="col-md-10 mt-4 pt-2">
                  <ClientThree/>
              </div>
          </div>
      </div>

      <div className="container mt-100 mt-60">
          <div className="row justify-content-center">
              <div className="col-12 text-center">
                  <div className="section-title">
                      <h4 className="title mb-4">See everything about your employee at one place.</h4>
                      <p className="text-muted para-desc mx-auto mb-0">Build responsive, mobile-first projects on the web with the world's most popular front-end component library.</p>
                  
                      <div className="mt-4">
                          <Link to="#" className="btn btn-primary mt-2 me-2">Get Started Now</Link>
                          <Link to="#" className="btn btn-outline-primary mt-2">Free Trial</Link>
                      </div>
                  </div>
              </div>
          </div>
      </div>
    </section>
    <Shape/>
    <Footer/>
    </>
  )
}
